import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  fallback?: string;
  className?: string;
}

const BackButton = ({ fallback = "/", className = "" }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Force fallback to provided route (defaults to home inside pages)
    navigate(fallback);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleBack}
      className={`shrink-0 ${className}`}
      aria-label="Go back"
    >
      <ArrowLeft className="h-5 w-5" />
    </Button>
  );
};

export default BackButton;
